import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { EditPlaylistComponent } from "../playlist/edit-playlist/edit-playlist.component";
import { AddToPlaylistComponent } from "./add-to-playlist/add-to-playlist.component";
import { ContentsComponent } from "./contents/contents.component";
import { HeaderComponent } from "./header/header.component";
import { ListContentsComponent } from "./list-contents/list-contents.component";
import { ModalTemplateComponent } from "./modal-template/modal-template.component";
import { SearchComponent } from "./search/search.component";
import { RouterModule } from "@angular/router";
import { LanguageSelectionComponent } from "./language-selection/language-selection.component";
import { SplashScreenComponent } from "./splash-screen/splash-screen.component";
import { TranslateModule } from "@ngx-translate/core";
import { PlyrModule } from "../lib/plyr/plyr.module";
import { AudioPlayerComponent } from "../player/audio-player/audio-player.component";
import { PlaybackEligibilityComponent } from "../player/audio-player/playback-eligibility/playback-eligibility.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PlyrModule,
    RouterModule,
    TranslateModule.forChild()
  ],
  exports: [
    AddToPlaylistComponent,
    ContentsComponent,
    HeaderComponent,
    ListContentsComponent,
    ModalTemplateComponent,
    SearchComponent,
    EditPlaylistComponent,
    LanguageSelectionComponent,
    SplashScreenComponent,
    AudioPlayerComponent,
    PlaybackEligibilityComponent
  ],
  declarations: [
    AddToPlaylistComponent,
    ContentsComponent,
    HeaderComponent,
    ListContentsComponent,
    ModalTemplateComponent,
    SearchComponent,
    EditPlaylistComponent,
    LanguageSelectionComponent,
    SplashScreenComponent,
    AudioPlayerComponent,
    PlaybackEligibilityComponent
  ]
})
export class ComponentsModule { }
